// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"abe217cd","408":"0808095e","449":"f9fedf37","841":"57833fb0","890":"a8bd5004"}[chunkId] + ".chunk.js";
};